/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, useCallback } from "react";
import "./AuthScreens.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAssessment } from "../assessmentState";
import { GENERATE_PLAN_URL, GET_STATE_LIST, PAYMENT, PAYMENT_CONFIRM, REGISTER_DATA_URL, RESEND_OTP, SET_NEW_EMAIL, USER_REGISTER, VERIFY_OTP } from "../GSA_CONSTANTS";
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
// ─── Constants ───────────────────────────────────────────────────────────────
const US_STATES = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];
const EX_COUNT = { "lower back": "100+", knee: "70+", hip: "70+", thigh: "70+" };
const DAY_LETTERS = ["S", "M", "T", "W", "T", "F", "S"];
const assessment = { diagnosisLabel: "knee", recoveryDurationPhrase: "about eight weeks" };

// ─── SVG helpers ─────────────────────────────────────────────────────────────
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
const CheckIconBold = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
const EyeOpen = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const EyeClosed = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
    <line x1="3" y1="3" x2="21" y2="21" />
  </svg>
);

// ─── Shared sub-components ────────────────────────────────────────────────────
function Stepper({ step }) {
  return (
    <div className="stepper">
      {[1, 2, 3, 4].map((n) => (
        <div key={n} className={`dot${n < step ? " done" : n === step ? " active" : ""}`} />
      ))}
      <span className="label">Step {step} of 4</span>
    </div>
  );
}

function MyraAvatar() {
  return <div className="myra-avatar">M</div>;
}

function AuthAside({ pitch, sub, probArea = "Lower Back" }) {
  let area = probArea;
  return (
    <aside className="auth-aside">
      <div className="aside-logo">
        virdio<span className="teal">health</span>
      </div>
      <div className="aside-pitch">
        <h2>{pitch || `Your ${area} plan is ready and waiting.`}</h2>
        <p>{sub || "Create your account and I'll save your plan, then guide you through it from day one."}</p>
      </div>
      <div className="aside-foot">MyPTMyra, powered by Virdio Health</div>
    </aside>
  );
}
function parseAssessmentData(rawData) {
  if (!rawData || typeof rawData !== "object") return null;
  console.log("raw data is : ", rawData);

  const plan = rawData.recoveryPlan || {};
  const exercises = plan.exercises || [];

  const today = new Date().toISOString().split("T")[0];

  const { recoveryPlan, exercises: _exercises, problem_id, sub_problem_id, clinical_protocol_id, rom, duration, rom2, duration2, analyticsId, ...restUserData } = rawData;

  const formatted = {
    program_name: "Week 1 Recovery Plan",
    problem_id: rawData.problem_id || 0,
    sub_problem_id: rawData.sub_problem_id || 0,
    clinical_protocol_id: rawData.clinical_protocol_id || 0,
    rom: rom || rawData.rom || [],
    duration: duration || rawData.duration || [],
    rom2: rom2 || rawData.rom2 || [],
    duration2: duration2 || rawData.duration2 || [],
    analyticsId: analyticsId || rawData?.analyticsId || null,
    tasks: exercises.map((exercise) => ({
      name: exercise.name || "Untitled",
      description: exercise.description || "",
      level: plan.level || "",
      rom: exercise.target_rom_max || 0,
      hold: exercise?.hold,
      duration: exercise.hold_in_seconds || 0,
      reps: exercise.reps || 4,
      sets: exercise.sets || 1,
      task_type: "exercise",
      category_type: 1,
      suggested_date: today,
      question_id: exercise.question_id || 0,
      activity_id: exercise.activity_id || exercise.equipment_id || null,
      set_limb_instruction: exercise.set_limb_instruction || {},
      performance_side: exercise.performance_side || "",
      purpose: exercise.purpose || "",
      rom_max: exercise.target_rom_max || 100,
    })),
    userData: restUserData,
  };

  return formatted;
}

// ─── SCREEN 1: Register ───────────────────────────────────────────────────────
export function RegisterScreen({ onNext }) {
  const area = assessment.diagnosisLabel;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [state, setState] = useState("");
  const [stateValid, setStateValid] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [terms, setTerms] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [stateOpen, setStateOpen] = useState(false);
  const [stateMatches, setStateMatches] = useState(US_STATES.slice());
  const [unitedStateStateList, setUnitedStateStateList] = useState([]);
  const [canadaStateList, setCanadaStateList] = useState([]);
  const [touched, setTouched] = useState({});
  const fieldOrder = ["firstName", "lastName", "email", "state", "phone", "password", "confirm"];

  const touchUpTo = (fieldName) => {
    const idx = fieldOrder.indexOf(fieldName);
    const toTouch = fieldOrder.slice(0, idx); // all fields before this one
    setTouched((prev) => {
      const next = { ...prev };
      toTouch.forEach((f) => (next[f] = true));
      return next;
    });
  };

  const touch = (field) => setTouched((prev) => ({ ...prev, [field]: true }));
  const [stateActiveIdx, setStateActiveIdx] = useState(-1);
  const stateComboRef = useRef(null);
  const history = useHistory();
  const { assessmentData, updateAssessmentData } = useAssessment();
  console.log("assessment data in register : ", assessmentData);
  localStorage.setItem("data2", assessmentData);
  const assessmentDataFromLocalStorage = JSON.parse(localStorage.getItem("assessmentData2"));
  console.log("assessmentDataFromLocalStorage : ", assessmentDataFromLocalStorage);
  const problemArea = assessmentData?.problemArea || assessmentDataFromLocalStorage?.problemArea;
  const [assessmentDataForBackend, setAssessmentDataForBackend] = useState(null);
  const sessionId = assessmentData?.analyticsId || assessmentDataFromLocalStorage?.analyticsId;

  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const phoneOk = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);
  const passLen = password.length >= 8;
  const passLetter = /[a-zA-Z]/.test(password);
  const passNum = /[0-9]/.test(password);
  const passSpec = /[^a-zA-Z0-9]/.test(password);
  const allPass = passLen && passLetter && passNum && passSpec;
  const confirmOk = confirm.length > 0 && confirm === password;

  const valid = firstName.length > 1 && lastName.length > 1 && emailOk && stateValid && phoneOk && allPass && confirmOk && terms;
  const missingHint = !valid ? [firstName.length <= 1 && "First name", lastName.length <= 1 && "Last name", !emailOk && "Email address", !stateValid && "State", !phoneOk && "Mobile number", !allPass && "Password", !confirmOk && "Confirm password", !terms && "Terms agreement"].filter(Boolean).join(", ") + " required." : "";

  // Close state dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (stateComboRef.current && !stateComboRef.current.contains(e.target)) {
        setStateOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (sessionId) {
      fetch(REGISTER_DATA_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: sessionId }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.responseCode === 200) {
            const decoded = atob(res.responseData);
            const parsed = JSON.parse(decoded);
            const backendData = parseAssessmentData(parsed);
            setAssessmentDataForBackend(backendData);
            localStorage.setItem("assessmentData", JSON.stringify(backendData));
          }
        })
        .catch((err) => console.error("register_data fetch failed:", err));
      return;
    }
  }, []);

  useEffect(() => {
    const getStateDropdown = async () => {
      if (!unitedStateStateList || unitedStateStateList.length === 0) {
        try {
          const response = await fetch(GET_STATE_LIST, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          });

          const data = await response.json();

          if (data.responseData) {
            const unitedStates = [];
            const canada = [];

            for (const country of data.responseData) {
              if (country.country === "United States") {
                unitedStates.push({ value: country.value });
              } else {
                canada.push({ value: country.value });
              }
            }

            setUnitedStateStateList(unitedStates);
            setCanadaStateList(canada);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };

    getStateDropdown();
    setTimeout(() => getStateDropdown(), 3000);
    setTimeout(() => getStateDropdown(), 10000);
  }, []);

  const filterStates = (q) => {
    const stateNames = unitedStateStateList.map((s) => s.value);
    const t = (q || "").trim().toLowerCase();
    if (!t) return stateNames;
    return stateNames.filter((s) => s.toLowerCase().startsWith(t));
  };
  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    if (digits.length <= 3) {
      return digits;
    }

    if (digits.length <= 6) {
      return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handleStateInput = (e) => {
    const v = e.target.value;
    setState(v);
    setStateValid(false);
    setStateActiveIdx(-1);
    setStateMatches(filterStates(v));
    setStateOpen(true);
  };

  const handleStateFocus = () => {
    touchUpTo("state");
    setStateActiveIdx(-1);
    setStateMatches(filterStates(state));
    setStateOpen(true);
  };

  const selectState = (s) => {
    setState(s);
    setStateValid(true);
    setStateOpen(false);
    setStateActiveIdx(-1);
  };

  const handleStateKey = (e) => {
    if (!stateOpen) {
      if (e.key === "ArrowDown") {
        setStateOpen(true);
      }
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setStateActiveIdx((i) => Math.min(i + 1, stateMatches.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setStateActiveIdx((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (stateActiveIdx >= 0 && stateMatches[stateActiveIdx]) {
        selectState(stateMatches[stateActiveIdx]);
      }
    } else if (e.key === "Escape") {
      setStateOpen(false);
    }
  };
  const handleSubmit = async () => {
    if (!valid) {
      setTouched({ firstName: true, lastName: true, email: true, state: true, phone: true, password: true, confirm: true });
      return;
    }
    const formData = { firstName, lastName, email, state, phone };
    updateAssessmentData({ ...formData });

    try {
      const response = await fetch(USER_REGISTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          birthday: "",
          email: email.trim().toLowerCase(),
          city: "city",
          country: "United States",
          state: state,
          phone: phone,
          password: password.trim(),
          session_id: sessionId || assessmentData?.analyticsId || assessmentDataFromLocalStorage?.analyticsId || null,
          company_id: localStorage.getItem("company_id") ? localStorage.getItem("company_id") : 0,
          business_id: localStorage.getItem("business_register") ? localStorage.getItem("business_register") : 0,
          newMemberRegister: true,
          company_doctor_id: 0,
          patient_code: "",
          assessmentData: assessmentDataForBackend || parseAssessmentData(assessmentDataFromLocalStorage),
        }),
      });

      const data = await response.json();

      if (data.responseCode === 200) {
        localStorage.setItem("userData", JSON.stringify(data.responseData));
        localStorage.setItem("isNew", "true");
        updateAssessmentData({
          currentUser: data.responseData,
        });
        const updatedAssessmentData = {
          ...assessmentDataFromLocalStorage,
          ...formData,
          currentUser: data.responseData,
        };
        localStorage.setItem("assessmentData2", JSON.stringify(updatedAssessmentData));
        history.push("/verify");
      } else {
        // optional: handle non-200 responses if backend sends structured error
        if (data?.errorData?.emailErr) {
          setEmailError(data.errorData.emailErr);
        }
      }
    } catch (error) {
      console.error(error);

      // fetch does NOT throw for HTTP errors automatically,
      // but network errors will land here
      if (error?.response?.data?.errorData?.emailErr) {
        setEmailError(error.response.data.errorData.emailErr);
      }
    }
  };
  return (
    <section className="screen active">
      <div className="auth-page">
        <AuthAside probArea={problemArea} />
        <main className="auth-main">
          <Stepper step={1} />
          <div className="head-block">
            <h1>You're one step from starting your {problemArea} plan.</h1>
            <div className="myra-beat">
              <MyraAvatar />
              <div className="beat-text">Let's set up your account so I can save your plan and check in as you go.</div>
            </div>
          </div>

          <div className="auth-card">
            <label className="field-label">Name</label>
            <div className="name-row">
              <div>
                <input className="field-input" type="text" placeholder="First Name" tabIndex={1} value={firstName} onChange={(e) => setFirstName(e.target.value.replace(/[^a-zA-Z\s'-]/g, ""))} onBlur={() => touch("firstName")} onFocus={() => touchUpTo("firstName")} />
              </div>
              <div>
                <input className="field-input" type="text" placeholder="Last Name" tabIndex={2} value={lastName} onChange={(e) => setLastName(e.target.value.replace(/[^a-zA-Z\s'-]/g, ""))} onBlur={() => touch("lastName")} onFocus={() => touchUpTo("lastName")} />
              </div>
            </div>
            {touched.firstName && firstName.length <= 1 && <div className="error-msg">Please enter a valid first name.</div>}
            {touched.lastName && lastName.length <= 1 && <div className="error-msg">Please enter a valid last name.</div>}

            <label className="field-label">Email Address</label>
            <input
              className={`field-input${email && !emailOk ? " error" : ""}`}
              type="email"
              placeholder="john@email.com"
              tabIndex={3}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError("");
              }}
              onBlur={() => touch("email")}
              onFocus={() => touchUpTo("email")}
            />
            {touched.email && email && !emailOk && <div className="error-msg">Please enter a valid email address.</div>}
            {touched.email && !email && <div className="error-msg">Email address is required.</div>}
            {emailError && <div className="error-msg">{emailError}</div>}

            <label className="field-label">State</label>
            <div className="combo" ref={stateComboRef}>
              <input
                className="combo-input"
                type="text"
                placeholder="Type or select your state"
                tabIndex={4}
                autoComplete="off"
                value={state}
                onChange={handleStateInput}
                onFocus={handleStateFocus}
                onKeyDown={handleStateKey}
                onBlur={() => {
                  touch("state");
                  setStateOpen(false);
                }}
              />
              <span className="combo-arrow">▾</span>
              <div className={`combo-list${stateOpen ? " open" : ""}`}>
                {stateMatches.length === 0 ? (
                  <div className="combo-empty">No matching state</div>
                ) : (
                  stateMatches.map((s, i) => (
                    <div
                      key={s}
                      className={`combo-option${i === stateActiveIdx ? " active" : ""}`}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        selectState(s);
                      }}
                    >
                      {s}
                    </div>
                  ))
                )}
              </div>
            </div>
            {touched.state && !stateValid && <div className="error-msg">Please select a valid state.</div>}
            {/* state error shown after user has typed something and blurred without selecting */}

            <label className="field-label">Mobile Number</label>
            <input
              className={`field-input${phone && !phoneOk ? " error" : ""}`}
              type="text"
              placeholder="e.g. 202-333-2222"
              tabIndex={5}
              value={phone}
              onChange={(e) => {
                setPhone(formatPhone(e.target.value));
              }}
              onBlur={() => touch("phone")}
              onFocus={() => touchUpTo("phone")}
            />
            {touched.phone && phone && !phoneOk && <div className="error-msg">Please enter a valid US mobile number.</div>}
            {touched.phone && !phone && <div className="error-msg">Mobile number is required.</div>}
            <p className="helper-text">You'll use this to sign in and receive session reminders. Standard rates apply.</p>

            <label className="field-label">Password</label>
            <div className="relative">
              <input className="field-input" type={showPass ? "text" : "password"} tabIndex={6} value={password} onChange={(e) => setPassword(e.target.value)} onBlur={() => touch("password")} onFocus={() => touchUpTo("password")} />
              <button type="button" className="eye-btn" tabIndex={-1} aria-label="Show password" onClick={() => setShowPass((v) => !v)}>
                {showPass ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
            {password && !allPass && (
              <div className="pass-rules">
                {[
                  { id: "len", ok: passLen, label: "At least 8 characters" },
                  { id: "letter", ok: passLetter, label: "1 letter" },
                  { id: "num", ok: passNum, label: "1 number" },
                  { id: "spec", ok: passSpec, label: "1 special character" },
                ].map((r) => (
                  <div key={r.id} className="pass-rule">
                    <span className={`pass-dot${r.ok ? " valid" : ""}`}>
                      <CheckIconBold />
                    </span>
                    {r.label}
                  </div>
                ))}
              </div>
            )}

            <label className="field-label">Confirm Password</label>
            <div className="relative">
              <input className={`field-input${confirm && !confirmOk ? " error" : ""}`} type={showConfirm ? "text" : "password"} tabIndex={7} value={confirm} onChange={(e) => setConfirm(e.target.value)} onBlur={() => touch("confirm")} onFocus={() => touchUpTo("confirm")} />
              <button type="button" className="eye-btn" tabIndex={-1} aria-label="Show password" onClick={() => setShowConfirm((v) => !v)}>
                {showConfirm ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
            {touched.confirm && confirm && !confirmOk && <div className="error-msg">Passwords don't match.</div>}
            {touched.confirm && !confirm && <div className="error-msg">Please confirm your password.</div>}

            <div className="terms-row">
              <div
                className={`checkbox${terms ? " checked" : ""}`}
                tabIndex={8}
                onClick={() => setTerms((v) => !v)}
                onKeyDown={(e) => {
                  if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    setTerms((v) => !v);
                  }
                }}
              >
                {terms && "✓"}
              </div>
              <div className="terms-text">
                I have read and agree to <a href="#">Virdio Health's Terms of Service</a>, <a href="#">Privacy Notice</a>, and <a href="#">HIPAA Notice</a>.
              </div>
            </div>

            <div className="submit-wrap" title={missingHint}>
              <button className="submit-btn" disabled={!valid} tabIndex={9} onClick={handleSubmit}>
                Create my account
              </button>
            </div>
          </div>
        </main>
      </div>
    </section>
  );
}

// ─── SCREEN 2: Verify ─────────────────────────────────────────────────────────
export function VerifyScreen({ onNext }) {
  const [code, setCode] = useState("");
  const [showBanner, setShowBanner] = useState(false);
  const [isChangingEmail, setIsChangingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isUpdatingEmail, setIsUpdatingEmail] = useState(false);
  const [linkOpen, setLinkOpen] = useState("");
  const [linkOpenClick, setLinkOpenClick] = useState(false);
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [codeError, setCodeError] = useState("");
  const history = useHistory();
  console.log("assessment data in verify : ", assessmentData);

  const assessmentDataFromLocalStorage = JSON.parse(localStorage.getItem("assessmentData2"));
  console.log("assessmentDataFromLocalStorage : ", assessmentDataFromLocalStorage);
  let problemArea = assessmentData?.problemArea || assessmentDataFromLocalStorage?.problemArea;

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return "Email is required";
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setNewEmail(value);
    setEmailError(validateEmail(value));
  };

  const handleUpdateEmail = async () => {
    const error = validateEmail(newEmail);
    if (error) {
      setEmailError(error);
      return;
    }

    setIsUpdatingEmail(true);
    const userData = JSON.parse(localStorage.getItem("userData"));

    fetch(SET_NEW_EMAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({
        firstName: userData?.first_name || "Virdio User",
        oldEmail: userData?.email || "",
        newEmail: newEmail.trim().toLowerCase(),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.responseCode === 200) {
          // Update localStorage with new email
          const updatedUser = { ...userData, email: newEmail };
          localStorage.setItem("userData", JSON.stringify(updatedUser));

          // Update assessment context
          updateAssessmentData({ email: newEmail });

          // Resend code to new email
          resendCode();

          setShowBannerMessage(`Email updated to ${newEmail}. A new verification code has been sent.`);
          setShowBanner(true);
          setIsChangingEmail(false);
          setNewEmail("");
          setEmailError("");
          setTimeout(() => setShowBanner(false), 5000);
        }
      })
      .catch((err) => {
        console.error("Failed to update email:", err);
        setEmailError("Failed to update email. Please try again.");
      })
      .finally(() => {
        setIsUpdatingEmail(false);
      });
  };
  const handleCancelEmailChange = () => {
    setIsChangingEmail(false);
    setNewEmail("");
    setEmailError("");
  };

  const getToken = () => {
    const userData = localStorage.getItem("userData");
    return userData ? JSON.parse(userData).token : "";
  };

  const resendCode = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    fetch(RESEND_OTP, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({
        firstName: userData?.first_name || "Virdio User",
        email: assessmentData.email || assessmentDataFromLocalStorage?.email || userData?.email || "",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.responseCode === 200) {
          setShowBannerMessage(`A verification code has been resent to ${assessmentData.email || "your email"}.`);
          setShowBanner(true);
          window.scrollTo(0, 0);
          setTimeout(() => setShowBanner(false), 5000);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    resendCode();
  }, []);

  const handleChangeEmailAddress = () => {
    setIsChangingEmail(true);
    setNewEmail(assessmentData.email || "");
  };

  // const handleVerify = () => {
  //   // Add verification logic here before navigating
  //   if (code.trim().length === 0) return;

  //   // Store verification code if needed
  //   updateAssessmentData({ verificationCode: code });

  //   // Navigate to subscription or next step
  //   history.push("/subscription");
  // };
  const handleVerify = () => {
    if (code.trim().length === 0) return;

    fetch(VERIFY_OTP, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({ code: code }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.responseCode === 200) {
          // Self-assessment flow: redirect back to the site
          // if (data.responseData.token && data.responseData.self_user === 1) {
          //   return;
          // }
          // Normal flow
          // if (data.responseData.userType === 1) {
          //   localStorage.removeItem("company_id");
          //   history.push("/initial_questionare");
          // } else if (data.responseData.userType === 2) {
          //   history.push("/dashboard");
          // }
          localStorage.setItem("userData", JSON.stringify(data.responseData));
          const fromSite = "https://myptmyra.com";
          const fullUrl = fromSite + `/?userId=${data.responseData.id}&userToken=${data.responseData.token}`;
          setLinkOpen(fullUrl);
          updateAssessmentData({ linkOpen: fullUrl });
          console.log("siteopen is : ", fullUrl);
          history.push("/subscription");
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.errorData?.codeErr) {
          // add a codeError state — see Fix 4
          setCodeError(err.response.data.errorData.codeErr);
        }
      });
  };

  const openNewTab = () => {
    setTimeout(() => setLinkOpenClick(true), 5000);
    window.open(linkOpen, "_blank", "noopener,noreferrer");
  };

  // Banner message state
  const [showBannerMessage, setShowBannerMessage] = useState("");

  return (
    <section className="screen active">
      {showBanner && (
        <div className="verify-banner show">
          <span>{showBannerMessage}</span>
          <span className="dismiss" onClick={() => setShowBanner(false)}>
            Dismiss
          </span>
        </div>
      )}
      <div className="auth-page">
        <AuthAside pitch="One quick step to secure your account." sub="Enter the code I sent to your email and phone, and your plan is ready to begin." probArea={problemArea} />
        <main className="auth-main">
          <Stepper step={2} />

          <div className="head-block">
            <h1>Verify your account</h1>
            <div className="myra-beat">
              <MyraAvatar />
              <div className="beat-text">
                I sent a code to <strong style={{ color: "var(--slate-800)", fontWeight: 600 }}>{assessmentDataFromLocalStorage.email || "your email"}</strong> and your phone. Pop it in below.
              </div>
            </div>
          </div>

          <div className="auth-card" style={{ maxWidth: "460px" }}>
            <label className="field-label">Security code</label>
            <input
              className="field-input"
              type="text"
              placeholder="Enter your code"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setCodeError("");
              }}
              disabled={isChangingEmail}
            />
            {codeError && <div className="error-msg">{codeError}</div>}

            <div style={{ height: "14px" }} />

            {/* Email Change UI */}
            {isChangingEmail ? (
              <div className="email-change-section">
                <label className="field-label">New Email Address</label>
                <input className={`field-input ${emailError ? "error" : ""}`} type="email" placeholder="Enter your new email address" value={newEmail} onChange={handleEmailChange} autoFocus />
                {emailError && <div className="error-msg">{emailError}</div>}

                <div className="email-change-actions">
                  <button className="action-btn cancel-btn" onClick={handleCancelEmailChange} disabled={isUpdatingEmail}>
                    Cancel
                  </button>
                  <button className="action-btn update-btn" onClick={handleUpdateEmail} disabled={!newEmail || emailError || isUpdatingEmail}>
                    {isUpdatingEmail ? "Updating..." : "Update Email"}
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="action-row">
                  <span className="action-desc">Didn't receive the code?</span>
                  <span className="action-link" onClick={resendCode}>
                    Resend Code
                  </span>
                </div>
                <div className="action-row">
                  <span className="action-desc">Wrong email?</span>
                  <span className="action-link" onClick={handleChangeEmailAddress}>
                    Change email address
                  </span>
                </div>
              </>
            )}

            <div className="info-box">
              <div className="icon">i</div>
              <div className="text">Please check your Updates, Promotions, Forums, and Spam folders too.</div>
            </div>

            <button className="submit-btn" disabled={code.trim().length === 0 || isChangingEmail} onClick={handleVerify}>
              Continue
            </button>
          </div>
        </main>
      </div>
    </section>
  );
}

// ─── SCREEN 3: Subscription ───────────────────────────────────────────────────
export function SubscriptionScreen({ onNext }) {
  const [plan, setPlan] = useState("week");
  const [seePlanOpen, setSeePlanOpen] = useState(false);
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  console.log("assessment data in subscription : ", assessmentData);
  const assessmentDataFromLocalStorage = JSON.parse(localStorage.getItem("assessmentData2"));
  console.log("assessmentDataFromLocalStorage : ", assessmentDataFromLocalStorage);
  const problemArea = assessmentData?.problemArea || assessmentDataFromLocalStorage?.problemArea;
  const area = assessment.diagnosisLabel;
  const count = assessmentDataFromLocalStorage?.planDetails?.exercises?.length || assessmentDataFromLocalStorage?.recoveryPlan?.exercises?.length;
  const handleSubscription = () => {
    const productId = plan === "full" ? "1" : "2";
    updateAssessmentData({ subscriptionPlan: plan, productId });
    const updatedAssessmentData = {
      ...assessmentDataFromLocalStorage,
      subscriptionPlan: plan,
      productId,
    };
    localStorage.setItem("assessmentData2", JSON.stringify(updatedAssessmentData));
    history.push("/payment");
  };

  return (
    <section className="screen active">
      <main className="sub-wrap">
        <Stepper step={3} />

        <div className="sub-eyebrow">Your plan is ready</div>
        <h1 className="sub-head">Choose how you want to pay</h1>
        <p className="sub-sub">Both options unlock the same plan. The only difference is billing.</p>

        <div className="value-strip">
          <div className="vh">What's included</div>
          <ul>
            <li className="incl-item">
              <CheckIcon />
              <div>
                Your recovery plan, tailored to you, to do as often as you want.{" "}
                <span className="see-plan-link" onClick={() => setSeePlanOpen((v) => !v)}>
                  {seePlanOpen ? "Hide my plan ▴" : "See my plan ▾"}
                </span>
              </div>
            </li>
            <li>
              <CheckIcon />
              Ask me questions anytime, I'm always available.
            </li>
            <li>
              <CheckIcon />I choose from {count} exercises for your {problemArea}, and adjust your plan as you progress.
            </li>
          </ul>

          <div className={`see-plan-body${seePlanOpen ? " open" : ""}`}>
            <div className="spb-note">This is your starting plan. I reshape it as you progress.</div>
            {(() => {
              const plan = assessmentData?.recoveryPlan || assessmentData?.planDetails || assessmentDataFromLocalStorage?.recoveryPlan || assessmentDataFromLocalStorage?.planDetails;
              const exercises = plan?.exercises || assessmentData?.exercises || assessmentDataFromLocalStorage?.exercises || [];

              if (!exercises.length) {
                return (
                  <div className="spb-ex">
                    <span>No exercises found.</span>
                  </div>
                );
              }

              // ── Phase grouping (mirrors PlanScreen logic exactly) ──
              const groupExercisesByPhase = (exList) => {
                if (!exList || exList.length === 0) return [];
                const hasPurpose = exList.some((ex) => ex.purpose || ex.phase);
                if (hasPurpose) {
                  const groups = { warmup: [], main: [], cooldown: [] };
                  exList.forEach((ex) => {
                    const p = (ex.purpose || ex.phase || "main").toLowerCase();
                    if (p.includes("warm")) groups.warmup.push(ex);
                    else if (p.includes("cool")) groups.cooldown.push(ex);
                    else groups.main.push(ex);
                  });
                  const result = [];
                  if (groups.warmup.length) result.push({ label: "Warm up", items: groups.warmup });
                  if (groups.main.length) result.push({ label: "Main work", items: groups.main });
                  if (groups.cooldown.length) result.push({ label: "Cool down", items: groups.cooldown });
                  return result;
                }
                if (exList.length === 1) return [{ label: "Main work", items: exList }];
                if (exList.length === 2)
                  return [
                    { label: "Warm up", items: [exList[0]] },
                    { label: "Main work", items: [exList[1]] },
                  ];
                return [
                  { label: "Warm up", items: [exList[0]] },
                  { label: "Main work", items: exList.slice(1, -1) },
                  { label: "Cool down", items: [exList[exList.length - 1]] },
                ];
              };

              // ── Dose label (mirrors PlanScreen display logic) ──
              const formatDose = (ex) => {
                const sets = ex.sets || 1;
                const reps = ex.reps || "";
                const hold = ex.hold ? `, hold ${ex.hold}s` : "";
                const side = ex.performance_side ? ` — ${ex.performance_side}` : "";
                return `${sets} set${sets !== 1 ? "s" : ""} of ${reps}${side}${hold}`;
              };

              return groupExercisesByPhase(exercises).map((group, gIdx) => (
                <React.Fragment key={gIdx}>
                  <div className="spb-grp">{group.label}</div>
                  {group.items.map((ex, i) => (
                    <div className="spb-ex" key={i}>
                      {ex.name}
                      {ex.performance_side ? ` — ${ex.performance_side}` : ""}
                      <span className="spb-dose">{formatDose(ex)}</span>
                    </div>
                  ))}
                </React.Fragment>
              ));
            })()}
          </div>
        </div>

        <div className="mini-cards">
          <div className={`mini-card${plan === "week" ? " sel" : ""}`} onClick={() => setPlan("week")}>
            <div className="mc-label">Weekly</div>
            <div className="mc-amt">$6.99</div>
            <div className="mc-det">
              first week, then $10.99/week.
              <br />
              <strong>Cancel anytime.</strong>
            </div>
          </div>
          <div className={`mini-card${plan === "full" ? " sel" : ""}`} onClick={() => setPlan("full")}>
            <div className="mc-badge save">Save 23%</div>
            <div className="mc-label">Pay once</div>
            <div className="mc-amt">$68</div>
            <div className="mc-det">
              full 8-week plan, one payment. Then $4.99/week.
              <br />
              <strong>Cancel anytime.</strong>
            </div>
          </div>
        </div>

        <button className="submit-btn" style={{ marginTop: "4px" }} onClick={handleSubscription}>
          Continue
        </button>
        <p className="secure-note">Secured by Stripe. Cancel anytime.</p>
      </main>
    </section>
  );
}

const STRIPE_ELEMENT_STYLE = {
  style: {
    base: {
      fontSize: "16px",
      color: "#333",
      fontFamily: "inherit",
      "::placeholder": { color: "#aaa" },
    },
    invalid: {
      color: "#e53e3e",
    },
  },
};

// ─── SCREEN 4: Payment ────────────────────────────────────────────────────────
export function PaymentScreen({ onNext }) {
  const stripe = useStripe();
  const elements = useElements();
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  const [ccZip, setCcZip] = useState("");

  const assessmentDataFromLocalStorage = JSON.parse(localStorage.getItem("assessmentData2"));
  const problemArea = assessmentData?.problemArea || assessmentDataFromLocalStorage?.problemArea;
  const count = assessmentDataFromLocalStorage?.planDetails?.exercises?.length || assessmentDataFromLocalStorage?.recoveryPlan?.exercises?.length;
  const productId = assessmentData?.productId || assessmentDataFromLocalStorage?.productId;
  const userData = JSON.parse(localStorage.getItem("userData"));

  const isWeekly = assessmentDataFromLocalStorage.subscriptionPlan !== "full";
  const billingText = isWeekly ? "$6.99 for your first week, then $10.99/week. Cancel anytime." : "$68 for your full 8-week plan, one payment. Then $4.99/week. Cancel anytime.";
  const unlockHead = isWeekly ? "Here's what you'll unlock, billed weekly:" : "Here's what you'll unlock, paid once:";
  const btnLabel = isWeekly ? "Pay $6.99 Now" : "Pay $68 Now";

  const [coupon, setCoupon] = useState("");
  const [useCoupon, setUseCoupon] = useState(false);
  const [payTerms, setPayTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Per-field validation errors from Stripe
  const [cardErrors, setCardErrors] = useState({
    cardNumber: "",
    cardExpiry: "",
    cardCvc: "",
  });

  // Track which fields are complete
  const [cardComplete, setCardComplete] = useState({
    cardNumber: false,
    cardExpiry: false,
    cardCvc: false,
  });

  const handleCardChange = (field) => (event) => {
    setCardErrors((prev) => ({ ...prev, [field]: event.error ? event.error.message : "" }));
    setCardComplete((prev) => ({ ...prev, [field]: event.complete }));
  };

  const cardReady = cardComplete.cardNumber && cardComplete.cardExpiry && cardComplete.cardCvc;
  const canPay = payTerms && (useCoupon ? coupon.trim().length > 0 : cardReady);

  const handlePayment = async () => {
    if (!canPay || loading) return;
    setLoading(true);
    setErrorMsg("");

    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const token = userData?.token?.trim();
      console.log("token being sent:", token);

      let paymentMethodId = null;

      // ── 1. Tokenize card via Stripe ───────────────────────────
      if (!useCoupon) {
        const cardNumber = elements.getElement(CardNumberElement);

        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card: cardNumber,
        });

        if (error) {
          setErrorMsg(error.message);
          setLoading(false);
          return;
        }

        paymentMethodId = paymentMethod.id;
      }
      console.log("Payload is : ", {
        productId,
        paymentMethodId,
        promoCode: useCoupon ? coupon.trim() : undefined,
      });

      // ── 2. Call backend ───────────────────────────────────────
      const res = await fetch(PAYMENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          productId,
          paymentMethodId,
          promoCode: useCoupon ? coupon.trim() : undefined,
          // currentUser: userData,
        }),
      });

      const data = await res.json();
      let result = data.responseData;
      console.log("result is : ", result);

      if (!res.ok) {
        setErrorMsg(data?.errorData?.error || data?.errorData?.message || data?.responseMessage || "Payment failed. Please try again.");
        setLoading(false);
        return;
      }

      // ── 3. Handle 3DS if needed ───────────────────────────────
      let paymentSucceeded = result.success;
      if (result.requiresAction && result.clientSecret) {
        const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(result.clientSecret);
        if (confirmError) {
          setErrorMsg(confirmError.message);
          setLoading(false);
          return;
        }
        if (paymentIntent.status !== "succeeded") {
          setErrorMsg("Payment not completed. Please try again.");
          setLoading(false);
          return;
        }

        const confirmRes = await fetch(PAYMENT_CONFIRM, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            paymentIntentId: paymentIntent.id,
            subscriptionId: result.subscriptionId,
          }),
        });

        const confirmData = await confirmRes.json();
        const confirmResult = confirmData.responseData;

        if (!confirmRes.ok || !confirmResult?.success) {
          setErrorMsg(confirmData?.errorData?.error || confirmData?.errorData?.message || confirmData?.responseMessage || "Payment succeeded, but account activation could not be verified. Please refresh or contact support.");
          setLoading(false);
          return;
        }

        result = { ...result, ...confirmResult };
        paymentSucceeded = true;
      }

      // ── 4. Success ────────────────────────────────────────────
      if (paymentSucceeded) {
        updateAssessmentData({ paidThroughDate: result.paidThroughDate });
        const updatedAssessmentData = {
          ...assessmentDataFromLocalStorage,
          paidThroughDate: result.paidThroughDate,
        };
        localStorage.setItem("assessmentData2", JSON.stringify(updatedAssessmentData));
        history.push("/settings");
      } else {
        setErrorMsg(result.error || "Payment failed. Please try again.");
      }
    } catch (err) {
      setErrorMsg("Something went wrong. Please try again.");
      console.error("[PaymentScreen] Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="screen active">
      <main className="pay-wrap">
        <Stepper step={4} />

        <div className="head-block" style={{ marginBottom: "20px" }}>
          <h1 style={{ fontSize: "1.5rem" }}>Upgrade to continue your full recovery plan</h1>
          <div className="myra-beat">
            <MyraAvatar />
            <div className="beat-text">Last step, then we start. You can cancel anytime.</div>
          </div>
        </div>

        <div className="unlock-box">
          <div className="uh">{unlockHead}</div>
          <div className="unlock-point">
            <CheckIcon />
            <span>Your recovery plan, tailored to you, to do as often as you want.</span>
          </div>
          <div className="unlock-point">
            <CheckIcon />
            <span>Ask me questions anytime, I'm always available.</span>
          </div>
          <div className="unlock-point">
            <CheckIcon />
            <span>
              I choose from {count} exercises for your {problemArea}, and adjust your plan as you progress.
            </span>
          </div>
          <div className="unlock-billing">{billingText}</div>
        </div>

        {/* ── Card Fields ──────────────────────────────────────── */}
        {!useCoupon && (
          <div id="card-section">
            <p className="pay-label">Card information</p>

            <label className="field-label" style={{ marginTop: 0 }}>
              Card number
            </label>
            <div className="field-input">
              <CardNumberElement options={STRIPE_ELEMENT_STYLE} onChange={handleCardChange("cardNumber")} />
            </div>
            {cardErrors.cardNumber && <p className="pay-field-error">{cardErrors.cardNumber}</p>}

            <div className="cc-row">
              <div>
                <label className="field-label">Expiry</label>
                <div className="field-input">
                  <CardExpiryElement options={STRIPE_ELEMENT_STYLE} onChange={handleCardChange("cardExpiry")} />
                </div>
                {cardErrors.cardExpiry && <p className="pay-field-error">{cardErrors.cardExpiry}</p>}
              </div>
              <div>
                <label className="field-label">CVC</label>
                <div className="field-input">
                  <CardCvcElement options={STRIPE_ELEMENT_STYLE} onChange={handleCardChange("cardCvc")} />
                </div>
                {cardErrors.cardCvc && <p className="pay-field-error">{cardErrors.cardCvc}</p>}
              </div>
              <div>
                <label className="field-label">ZIP</label>
                <input className="field-input" type="text" inputMode="numeric" placeholder="ZIP" value={ccZip} onChange={(e) => setCcZip(e.target.value)} />
              </div>
            </div>
          </div>
        )}

        {/* ── Coupon Field ─────────────────────────────────────── */}
        {useCoupon && (
          <div className="coupon-field open">
            <p className="pay-label">Coupon code</p>
            <input className="field-input" type="text" placeholder="Enter coupon code" value={coupon} onChange={(e) => setCoupon(e.target.value)} />
          </div>
        )}

        <span className="coupon-toggle" onClick={() => setUseCoupon((v) => !v)}>
          {useCoupon ? "Use card instead" : "Have a coupon code? Tap to enter"}
        </span>

        {/* ── Global Error ─────────────────────────────────────── */}
        {errorMsg && <p style={{ color: "#e53e3e", fontSize: "0.875rem", marginTop: "8px" }}>{errorMsg}</p>}

        <div className="pay-terms">
          <div className={`checkbox${payTerms ? " checked" : ""}`} onClick={() => setPayTerms((v) => !v)}>
            {payTerms && "✓"}
          </div>
          <span>
            I agree to the{" "}
            <a href="https://virdiohealth.com/terms.html" target="_blank" rel="noreferrer">
              Terms of Service
            </a>
          </span>
        </div>

        <button className="submit-btn" style={{ marginTop: "4px" }} disabled={!canPay || loading} onClick={handlePayment}>
          {loading ? "Processing…" : btnLabel}
        </button>
        <p className="secure-note">Secured by Stripe. Cancel anytime from your account.</p>
      </main>
    </section>
  );
}

// ─── SCREEN 5: Settings ───────────────────────────────────────────────────────
export function SettingsScreen() {
  const [daysPerWeek, setDaysPerWeek] = useState(4);
  const [sessionsPerDay, setSessionsPerDay] = useState("one");
  const [dayPickerOpen, setDayPickerOpen] = useState(false);
  const [chosenDays, setChosenDays] = useState([]);
  const [weekOrder, setWeekOrder] = useState([]);
  const [confirmExtra, setConfirmExtra] = useState(null); // { dayIdx, nextCount } | null
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  console.log("assessment data in settings : ", assessmentData);
  const assessmentDataFromLocalStorage = JSON.parse(localStorage.getItem("assessmentData2"));
  const userData = JSON.parse(localStorage.getItem("userData"));

  // Build week order from today
  useEffect(() => {
    const todayIdx = new Date().getDay();
    const order = [];
    for (let k = 0; k < 7; k++) order.push((todayIdx + k) % 7);
    setWeekOrder(order);
  }, []);

  const autoSpread = (n) => {
    const step = 7 / n;
    const positions = [];
    for (let i = 0; i < n; i++) positions.push(Math.round(i * step) % 7);
    return positions.map((pos) => weekOrder[pos]);
  };

  const spreadDays = autoSpread(daysPerWeek);

  const pickDays = (n) => {
    setDaysPerWeek(n);
    setChosenDays([]);
  };

  const toggleDayPicker = () => {
    const next = !dayPickerOpen;
    setDayPickerOpen(next);
    if (next && chosenDays.length === 0) setChosenDays([]);
  };

  // const toggleDay = (dayIdx) => {
  //   setChosenDays((prev) => {
  //     const has = prev.includes(dayIdx);
  //     if (has) return prev.filter((d) => d !== dayIdx);
  //     if (prev.length >= daysPerWeek) {
  //       if (daysPerWeek >= 7) return prev;
  //       const next = daysPerWeek + 1;
  //       const ok = window.confirm(`You picked ${daysPerWeek} days a week. Add another and do ${next} days instead?`);
  //       if (!ok) return prev;
  //       setDaysPerWeek(next);
  //       return [...prev, dayIdx];
  //     }
  //     return [...prev, dayIdx];
  //   });
  // };
  const toggleDay = (dayIdx) => {
    setChosenDays((prev) => {
      const has = prev.includes(dayIdx);
      if (has) return prev.filter((d) => d !== dayIdx);
      if (prev.length >= daysPerWeek) {
        if (daysPerWeek >= 7) return prev;
        // Instead of window.confirm, show inline prompt
        setConfirmExtra({ dayIdx, nextCount: daysPerWeek + 1 });
        return prev;
      }
      return [...prev, dayIdx];
    });
  };

  const confirmAddDay = () => {
    if (!confirmExtra) return;
    setDaysPerWeek(confirmExtra.nextCount);
    setChosenDays((prev) => [...prev, confirmExtra.dayIdx]);
    setConfirmExtra(null);
  };

  const dayHint = () => {
    if (!dayPickerOpen) return "";
    if (chosenDays.length === 0) return `A recommended spread for ${daysPerWeek} days. Tap to choose your own.`;
    const remaining = daysPerWeek - chosenDays.length;
    if (remaining > 0) return `Pick ${remaining} more ${remaining === 1 ? "day" : "days"} (${daysPerWeek} total).`;
    return `That's your ${daysPerWeek} days.`;
  };

  const getDayState = (dayIdx) => {
    if (chosenDays.includes(dayIdx)) return "selected";
    if (dayPickerOpen && chosenDays.length === 0 && spreadDays.includes(dayIdx)) return "auto";
    return "";
  };

  const finishSettings = () => {
    const days =
      dayPickerOpen && chosenDays.length === daysPerWeek
        ? chosenDays
            .slice()
            .sort((a, b) => a - b)
            .join(",")
        : "auto-spread";
  };
  const handleStartPlan = async () => {
    const sessionDays =
      dayPickerOpen && chosenDays.length === daysPerWeek
        ? chosenDays
            .slice()
            .sort((a, b) => a - b)
            .join(",")
        : "auto-spread";
    updateAssessmentData({
      scheduleDays: daysPerWeek,
      sessionPref: sessionsPerDay,
      sessionDays: sessionDays,
    });
    const updatedAssessmentData = {
      ...assessmentDataFromLocalStorage,
      scheduleDays: daysPerWeek,
      sessionPref: sessionsPerDay,
      sessionDays: sessionDays,
    };
    localStorage.setItem("assessmentData2", JSON.stringify(updatedAssessmentData));

    try {
      const planResponse = await fetch(GENERATE_PLAN_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: userData.id,
          assessmentData: parseAssessmentData(updatedAssessmentData),
        }),
      });
      const planData = await planResponse.json();
      console.log("generate-plan response:", planData);
    } catch (err) {
      console.error("Failed to generate week 1 plan:", err);
    }
    const fromSite = "https://virdio-ar.weborik.com/";
    const fullUrl = fromSite + `/?userId=${userData.id}&userToken=${userData.token}`;
    console.log("fromSite:", fromSite);
    console.log("fullUrl:", fullUrl);
    console.log("responseData:", userData);
    // window.open(fullUrl, "_blank", "noopener,noreferrer");
    window.location.replace(fullUrl);
  };

  return (
    <section className="screen active">
      <main className="settings-wrap">
        <div className="head-block">
          <h1 style={{ fontSize: "1.5rem" }}>Set your weekly rhythm</h1>
          <div className="myra-beat">
            <MyraAvatar />
            <div className="beat-text">You're in. Pick a pace for week one, change it anytime in the app.</div>
          </div>
        </div>

        <div className="settings-block">
          <label>Days per week</label>
          <div className="pill-row">
            {[3, 4, 5, 6, 7].map((n) => (
              <div key={n} className={`pill${daysPerWeek === n ? " selected" : ""}`} data-days={n} onClick={() => pickDays(n)}>
                {n}
              </div>
            ))}
          </div>
          <div className="rec-line">While pain is fresh, most days has the biggest impact in week one.</div>

          <div className="day-toggle">
            <span className="toggle-link" onClick={toggleDayPicker}>
              {dayPickerOpen ? "－ Use a recommended spread instead" : "＋ Choose your specific days"}
            </span>
            {dayPickerOpen && (
              <div className="day-picker open">
                <div className="day-hint">{dayHint()}</div>
                <div className="day-row">
                  {weekOrder.map((dayIdx, pos) => (
                    <div key={pos} className={`day-cell${getDayState(dayIdx) ? ` ${getDayState(dayIdx)}` : ""}`} onClick={() => toggleDay(dayIdx)}>
                      {DAY_LETTERS[dayIdx]}
                    </div>
                  ))}
                </div>
                {confirmExtra && (
                  <div className="day-confirm-banner">
                    <p className="day-confirm-text">
                      You picked {daysPerWeek} days a week. Add another and do {confirmExtra.nextCount} days instead?
                    </p>
                    <div className="day-confirm-actions">
                      <button className="day-confirm-btn yes" onClick={confirmAddDay}>
                        Yes, do {confirmExtra.nextCount} days
                      </button>
                      <button className="day-confirm-btn no" onClick={() => setConfirmExtra(null)}>
                        No, keep {daysPerWeek}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="settings-block">
          <label>Sessions per day</label>

          <div className="pill-row">
            <div className={`pill${sessionsPerDay === "one" ? " selected" : ""}`} onClick={() => setSessionsPerDay("one")}>
              One
            </div>

            <div className={`pill${sessionsPerDay === "multiple" ? " selected" : ""}`} onClick={() => setSessionsPerDay("multiple")}>
              Multiple
            </div>
          </div>

          <div className="rec-line">Multiple sessions per day can ease pain faster early on.</div>
        </div>

        <button className="submit-btn" onClick={handleStartPlan}>
          Start my first week
        </button>
      </main>
    </section>
  );
}

// ─── PROTOTYPE NAV BAR ────────────────────────────────────────────────────────
function ProtoBar({ currentScreen, onGoTo }) {
  const screens = [
    { id: "register", label: "1 · Register" },
    { id: "verify", label: "2 · Verify" },
    { id: "subscription", label: "3 · Subscription" },
    { id: "payment", label: "4 · Payment" },
    { id: "settings", label: "5 · Settings" },
  ];
  return (
    <div className="proto-bar">
      <span>Jump:</span>
      {screens.map((s) => (
        <button key={s.id} className={currentScreen === s.id ? "on" : ""} onClick={() => onGoTo(s.id)}>
          {s.label}
        </button>
      ))}
    </div>
  );
}

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function StartFreePT() {
  const [screen, setScreen] = useState("register");
  const [sharedData, setSharedData] = useState({});

  const goTo = useCallback((name, data = {}) => {
    setSharedData((prev) => ({ ...prev, ...data }));
    setScreen(name);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {screen === "register" && <RegisterScreen onNext={goTo} />}
      {screen === "verify" && <VerifyScreen onNext={goTo} email={sharedData.email} />}
      {screen === "subscription" && <SubscriptionScreen onNext={goTo} />}
      {screen === "payment" && <PaymentScreen onNext={goTo} plan={sharedData.plan} />}
      {screen === "settings" && <SettingsScreen />}
      <ProtoBar currentScreen={screen} onGoTo={(name) => goTo(name)} />
    </>
  );
}
